//Styles
import { ReactNode } from "react";
import Styles from "./RadioGroup.module.scss";
import classnames from "classnames";
import RadioButton from "./radio-button/RadioButton";

interface RadioBoxGroupProps {
  title?: string | ReactNode;
  selectedOption: any;
  handleChange: (id: string) => void;
  options: any
  layout?: "flex" | "block";
  size?:"small" | "medium"
}

const RadioBoxGroup = ({ title, selectedOption, options, layout="block", size="medium",  handleChange }: RadioBoxGroupProps) => {


  const handleOptionChange = async (id: any,onOptionClick?:()=>void) => {
    handleChange(id);
    onOptionClick?.()
  };

  return (
    <div className={Styles.container}>
      {title && <div className={Styles.title}>{title}</div>}
      <div className={classnames(Styles[layout],Styles[size])}>
        {
          options.map((option: any) => {
            return (
                <RadioButton layout={layout} size={size} id={option.id} onClick={option.onClick} label={option.label} value={option.value} isChecked={selectedOption === option.id} handleOptionClick={handleOptionChange} key={option.id}/>
            )
          })
        }
      </div>
    </div>
  );
};

export default RadioBoxGroup;